<template>
    <v-row class="d-flex align-center flex-wrap ma-0 pa-0">
        <!-- Selezione calendario -->
        <v-btn-toggle v-model="localSelezione" mandatory class="rounded-lg my-toggle mr-2 mt-2" :dense="dense">
            <v-btn value="calendar" icon v-tooltip.bottom="'Passa al calendario'">
                <v-icon>date_range</v-icon>
            </v-btn>
            <v-btn value="tasks" icon v-tooltip.bottom="'Passa alle attività'">
                <v-icon>task_alt</v-icon>
            </v-btn>
        </v-btn-toggle>

        <v-btn text icon class="ml-0 mt-2" @click="$emit('refresh')">
            <v-icon>refresh</v-icon>
        </v-btn>

        <!-- Navigazione mesi -->
        <v-btn class="mt-2" text icon @click="$emit('prev')"><v-icon>keyboard_arrow_left</v-icon></v-btn>
        <span class="mt-2" style="width: 100px; text-align: center;">{{ meseCorrente }}</span>
        <v-btn class="mt-2" text icon @click="$emit('next')"><v-icon>keyboard_arrow_right</v-icon></v-btn>

        <!-- Aggiungi -->
        <v-btn icon color="primary" @click="$emit('apriDialog')" class="mt-2"
            v-if="!$vuetify.breakpoint.smAndDown"><v-icon>add</v-icon></v-btn>

        <!-- Filtro utente -->
        <v-select v-if="role == 'admin'" class="ml-2 mt-2" :items="filtriUtenti" v-model="localFiltroUtenteSel"
            label="Utente" hide-details :dense="dense" @change="$emit('refresh')" style="max-width: 120px;" />

        <!-- Esporta -->
        <v-btn v-if="role == 'admin'" icon color="primary" class="ml-2 mt-2" @click="$emit('esportaExcel')">
            <v-icon>grid_on</v-icon>
        </v-btn>

        <!-- Mostra completate -->
        <v-checkbox v-if="localSelezione == 'tasks'" v-model="localMostraCompletate" label="Mostra completate"
            class="ml-2 mt-2 pt-0" hide-details :dense="dense" @change="$emit('refresh')" />

        <v-spacer />

        <!-- Cerca -->
        <v-text-field v-model="localSearch" append-icon="search" label="Filtro" hide-details clearable
            class="ml-2 pb-1 mt-2" :dense="dense" />
    </v-row>
</template>

<script>
export default {
    props: {
        today: String,
        role: String,
        selezione: String,
        filtroUtenteSel: String,
        filtriUtenti: Array,
        mostraCompletate: Boolean,
        search: String,
        dense: Boolean
    },
    computed: {
        meseCorrente() {
            return new Date(this.today).toLocaleString("it", { month: "long" });
        },
        localSelezione: {
            get() { return this.selezione; },
            set(v) { this.$emit("update:selezione", v); }
        },
        localFiltroUtenteSel: {
            get() { return this.filtroUtenteSel; },
            set(v) { this.$emit("update:filtroUtenteSel", v); }
        },
        localMostraCompletate: {
            get() { return this.mostraCompletate; },
            set(v) { this.$emit("update:mostraCompletate", v); }
        },
        localSearch: {
            get() { return this.search; },
            set(v) { this.$emit("update:search", v); }
        }
    }
};
</script>

<style scoped>
</style>